import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "my-4" }
const _hoisted_2 = { class: "user-icon" }
const _hoisted_3 = { class: "user-letter" }
const _hoisted_4 = { class: "user-msg mt-2 mb-2" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "chat-bubble"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_Code = _resolveComponent("Code")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, { class: "msg my-2" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.userLetter), 1)
        ]),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.userMessage), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, { class: "msg" }, {
      default: _withCtx(() => [
        (_ctx.agentMessageFormatted !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_Code, { msg: _ctx.agentMessageFormatted }, null, 8, ["msg"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "typing" }, [
                _createElementVNode("div", { class: "dot" }),
                _createElementVNode("div", { class: "dot" }),
                _createElementVNode("div", { class: "dot" })
              ], -1)
            ])))
      ]),
      _: 1
    })
  ]))
}